// Error monitoring via Sentry.
//
// Sentry initializes only when VITE_SENTRY_DSN is provided. The SDK is loaded
// dynamically so it is excluded from the main bundle when monitoring is off.

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const ENVIRONMENT = (import.meta.env.MODE as string) || "production";

let initialized = false;

/**
 * Boot Sentry error monitoring. Idempotent and browser-only. No-ops when no
 * DSN is configured.
 */
export async function initMonitoring(): Promise<void> {
  if (initialized || typeof window === "undefined" || !SENTRY_DSN) return;
  initialized = true;
  const Sentry = await import("@sentry/react");
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}
